/** Play UI text, as pure functions. */

/** Seconds as the PIE clock shows them (reference 05): "00:00:14". */
export function formatPlayClock(seconds: number): string {
  const two = (n: number) => String(Math.floor(n)).padStart(2, "0");
  return `${two(seconds / 3600)}:${two((seconds % 3600) / 60)}:${two(seconds % 60)}`;
}
